import * as React from 'react'
function SvgHeartFilled(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.364 8.636a9.001 9.001 0 00-12.728 0c-.242.242-.428.518-.636.778-.208-.26-.394-.536-.636-.778a9.001 9.001 0 00-12.728 0 9.001 9.001 0 000 12.728l11.99 11.337a2 2 0 002.748 0l11.99-11.337a9.001 9.001 0 000-12.728z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgHeartFilled
